const setDataForSalesTable = (payload) => {
  return {
    type: "setDataForSalesTable",
    payload,
  };
};
export default setDataForSalesTable;
